import * as Types from '../types';

// Domain shapes are not inspected in this module; keep them minimal.
type Invite = Record<string, unknown>;
type InviteResult = Record<string, unknown>;
type InviteError = unknown;

interface ReqProductAccessInviteUsersAction {
  type: typeof Types.REQ_PRODUCT_ACCESS_INVITE_USERS;
  payload: {
    emailAddresses: string[];
    costCenterId: string;
    productAccessId: string;
  };
}

export function reqProductAccessInviteUsers(
  emailAddresses: string[],
  costCenterId: string,
  productAccessId: string,
): ReqProductAccessInviteUsersAction {
  return {
    type: Types.REQ_PRODUCT_ACCESS_INVITE_USERS,
    payload: {
      emailAddresses,
      costCenterId,
      productAccessId,
    },
  };
}

interface ClientProductAccessInviteUsersResultAction {
  type: typeof Types.CLIENT_PRODUCT_ACCESS_INVITE_USERS_RESULT;
  payload: {
    open: boolean;
    success: boolean;
    result: InviteResult;
    error: InviteError;
  };
}

export function clientProductAccessInviteUsersResult(
  open: boolean,
  success: boolean,
  result: InviteResult = {},
  error: InviteError = null,
): ClientProductAccessInviteUsersResultAction {
  return {
    type: Types.CLIENT_PRODUCT_ACCESS_INVITE_USERS_RESULT,
    payload: {
      open,
      success,
      result,
      error,
    },
  };
}

interface ClientProductAccessInviteUsersResultClearAction {
  type: typeof Types.CLIENT_PRODUCT_ACCESS_INVITE_USERS_RESULT_CLEAR;
}

export function clientProductAccessInviteUsersResultClear(): ClientProductAccessInviteUsersResultClearAction {
  return {
    type: Types.CLIENT_PRODUCT_ACCESS_INVITE_USERS_RESULT_CLEAR,
  };
}

interface ReqProductAccessCancelInvitesAction {
  type: typeof Types.REQ_PRODUCT_ACCESS_CANCEL_INVITES;
  payload: {
    inviteIds: Invite[];
  };
}

export function reqProductAccessCancelInvites(
  inviteIds: Invite[],
): ReqProductAccessCancelInvitesAction {
  return {
    type: Types.REQ_PRODUCT_ACCESS_CANCEL_INVITES,
    payload: {
      inviteIds,
    },
  };
}

interface ReqProductAccessResendInvitesAction {
  type: typeof Types.REQ_PRODUCT_ACCESS_RESEND_INVITES;
  payload: {
    invites: Invite[];
  };
}

export function reqProductAccessResendInvites(
  invites: Invite[],
): ReqProductAccessResendInvitesAction {
  return {
    type: Types.REQ_PRODUCT_ACCESS_RESEND_INVITES,
    payload: {
      invites,
    },
  };
}

interface ClientProductAccessCancelInvitesResultAction {
  type: typeof Types.CLIENT_PRODUCT_ACCESS_CANCEL_INVITES_RESULT;
  payload: {
    open: boolean;
    success: boolean;
    result: InviteResult;
    error: InviteError;
  };
}

export function clientProductAccessCancelInvitesResult(
  open: boolean,
  success: boolean,
  result: InviteResult = {},
  error: InviteError = null,
): ClientProductAccessCancelInvitesResultAction {
  return {
    type: Types.CLIENT_PRODUCT_ACCESS_CANCEL_INVITES_RESULT,
    payload: {
      open,
      success,
      result,
      error,
    },
  };
}

interface ClientProductAccessCancelInvitesResultClearAction {
  type: typeof Types.CLIENT_PRODUCT_ACCESS_CANCEL_INVITES_RESULT_CLEAR;
}

export function clientProductAccessCancelInvitesResultClear(): ClientProductAccessCancelInvitesResultClearAction {
  return {
    type: Types.CLIENT_PRODUCT_ACCESS_CANCEL_INVITES_RESULT_CLEAR,
  };
}

interface ClientProductAccessInvitesSyncAction {
  type: typeof Types.CLIENT_PRODUCT_ACCESS_INVITES_SYNC;
  payload: {
    invites: Invite[];
  };
}

export function clientProductAccessInvitesSync(
  invites: Invite[],
): ClientProductAccessInvitesSyncAction {
  const action: ClientProductAccessInvitesSyncAction = {
    type: Types.CLIENT_PRODUCT_ACCESS_INVITES_SYNC,
    payload: {
      invites,
    },
  };
  return action;
}
